import { Field, FieldFooter } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import EquipmentTypePicker, {
  IEquipmentTypePickerProps,
} from 'components/domain/equipment/EquipmentTypePicker/EquipmentTypePicker';

interface IEquipmentTypeFormFieldProps extends Omit<IEquipmentTypePickerProps, 'value' | 'onSelect'> {
  className?: string | object;
  form: any;
  name: string;
  onChange?: (value: string | null) => void;
  validations?: any;
}

function EquipmentTypeFormField(props: IEquipmentTypeFormFieldProps) {
  const { form, name, validations, className, onChange, ...other } = props;

  const classes = classNames(
    {
      'equipment-type-picker-form-field': true,
    },
    className
  );

  function renderField({ ...fieldProps }) {
    function handleOnSelect(val: string | null) {
      fieldProps.handleChange(val, onChange);
    }

    return (
      <>
        <EquipmentTypePicker
          error={fieldProps.hasError}
          value={form.state.data[name]}
          onSelect={handleOnSelect}
          {...other}
        />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  return <Field form={form} name={name} validations={validations} className={classes} render={renderField} />;
}

export default EquipmentTypeFormField;
